import { PriceType } from '../common/PriceType';

export type RecurrenceFreq = 'DAILY' | 'WEEKLY' | 'BIWEEKLY' | 'MONTHLY' | 'WEEKLY_DAYS';

/** A catalog item is either a 1-client SERVICE or a group EVENT (workshop). */
export type ServiceKind = 'SERVICE' | 'EVENT';

export interface Service {
    id: string;
    businessId: number;
    name?: string | null;
    description?: string | null;
    categories?: string[] | null;
    color?: string | null;
    showOnWebSite?: boolean | null;
    image?: string | null;
    totalDuration?: number | null;
    startPreparationDuration?: number | null;
    endPreparationDuration?: number | null;
    allowBookingDuringPreparationDuration?: boolean | null;
    startAfterDuration?: number | null;
    endAfterDuration?: number | null;
    allowBookingDuringAfterDuration?: boolean | null;
    price?: number | null;
    priceType?: PriceType | null;
    /** SERVICE (1-client appointment, default/null) or EVENT (group workshop). */
    kind?: ServiceKind | null;
    /** EVENT only: max participants (null = unlimited). */
    capacity?: number | null;
    /** Optional tax-rate override (%). Null/undefined = inherit the company default. */
    taxRate?: number | null;
    depositRequired?: boolean | null;
    amountDepositRequired?: number | null;
    allowRecurring?: boolean | null;
    /** Override da classificação de saúde da categoria. null = herda. */
    isHealthDataOverride?: boolean | null;
    /** Derivado no backend: override ?? categoria. */
    isHealthDataResolved?: boolean | null;
    recurrenceFreqs?: RecurrenceFreq[] | null;
    maxRecurrenceMonths?: number | null;
    /** Whether this service is offered for online booking (consumer marketplace). */
    allowOnlineBooking?: boolean | null;
    /** Min lead time (minutes) to book this service (null = business default). */
    bookingWindow?: number | null;
    /** Can be performed at the client's address (house call). */
    allowExternalLocation?: boolean | null;
    /** Health plans (convênios) this service accepts + negotiated values. */
    acceptedPlans?: AcceptedPlan[] | null;
}

/** How the plan's repasse (what it actually pays the business) is expressed. */
export type RepasseType = 'PERCENT' | 'VALUE';

/** A health plan accepted by a service, with its table value and the repasse. */
export interface AcceptedPlan {
    /** business-service health_plan id. */
    healthPlanId: number;
    /** The plan's table value for this service ("valor de tabela"). */
    negotiatedValue?: number | null;
    /** Repasse expression: PERCENT (% of table) or VALUE (fixed amount). */
    repasseType?: RepasseType | null;
    /** Repasse figure — % when PERCENT, currency amount when VALUE. */
    repasseValue?: number | null;
}

/**
 * What the plan actually pays the business for this service (the receivable).
 * PERCENT → table × %/100; VALUE → the fixed amount; not informed → the full
 * table value (fallback).
 */
export function effectiveRepasse(plan: AcceptedPlan): number {
    const table = plan.negotiatedValue ?? 0;
    if (plan.repasseValue == null) return table;
    if (plan.repasseType === 'PERCENT') {
        return Math.round(table * plan.repasseValue) / 100;
    }
    return plan.repasseValue;
}
